import { QueryCache, QueryClient } from '@tanstack/react-query';
import { TEN_MINUTES } from 'lib/config/appConstants';

export const queryClient = new QueryClient({
  queryCache: new QueryCache({}),
  defaultOptions: {
    queries: {
      staleTime: TEN_MINUTES,
      gcTime: Infinity,
    },
  },
});
